/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface RegionSearchPublic
 */
export interface RegionSearchPublic {
  /**
   *
   * @type {number}
   * @memberof RegionSearchPublic
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof RegionSearchPublic
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof RegionSearchPublic
   */
  subdomain?: string | null
  /**
   *
   * @type {string}
   * @memberof RegionSearchPublic
   */
  province?: string | null
  /**
   *
   * @type {Array<string>}
   * @memberof RegionSearchPublic
   */
  readonly matchedCities: Array<string>
}

/**
 * Check if a given object implements the RegionSearchPublic interface.
 */
export function instanceOfRegionSearchPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'matchedCities' in value

  return isInstance
}

export function RegionSearchPublicFromJSON(json: any): RegionSearchPublic {
  return RegionSearchPublicFromJSONTyped(json, false)
}

export function RegionSearchPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RegionSearchPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    subdomain: !exists(json, 'subdomain') ? undefined : json['subdomain'],
    province: !exists(json, 'province') ? undefined : json['province'],
    matchedCities: json['matchedCities'],
  }
}

export function RegionSearchPublicToJSON(value?: RegionSearchPublic | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    subdomain: value.subdomain,
    province: value.province,
  }
}
